import { render, staticRenderFns } from "./SdAppSnap.vue?vue&type=template&id=643cc6b8&scoped=true"
import script from "./SdAppSnap.vue?vue&type=script&lang=js"
export * from "./SdAppSnap.vue?vue&type=script&lang=js"
import style0 from "./SdAppSnap.vue?vue&type=style&index=0&id=643cc6b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "643cc6b8",
  null
  
)

export default component.exports